// import the react components
import React from "react"

// import the custome components
import Button from "./../button";

// import the styles
import {tr_style, td_style} from "./../../assets/data/style";

// the received item functional based component
const ReceivedItem = ({item}) => {

    // return to the component data
    return (
        <tr className={tr_style}>
            <td className={td_style}>{item.id}</td>
            <td className={td_style}>{item.from_username}</td>
            <td className={td_style}>{item.treatments}</td>
            <td className={td_style}>
                <Button title="edit" action="link" link={`/book/${item.patient}`} />
            </td>
            <td className={td_style}>
                <Button title="view" action="link" link={`/view/patient/${item.patient}`} />
            </td>
        </tr>
    );
};
export default ReceivedItem;